import React, { useEffect, useState } from 'react'
//import { ExamDto, Person, PersonApi, StarterDto, StarterExmsDto, StarterResponse, BookedExamResponse, StartersApi, BookedExamResponseFromJSON } from '../api'
import { StarterExmsDto, ExamDto, Person, PersonApi, StarterResponse, BookedExamResponse, StartersApi } from '../api'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { authState } from '../state/Auth.state'
import { registrationState } from '../components/pages/registration/Registration.state'
import { actualShowState } from '../state/ActualShow.state'
import { useLocalState } from './UseLocalState'
import { format } from 'date-fns'

const Persons = new Map<string, Person>()

export const PersonByRegId = ({ regId }: { regId?: string | null }) => {
  /* STATE */
  const [person, setPerson] = useState<Person | undefined>(undefined)
  const exams = useLocalState<ExamDto[]>(actualShowState.actualShowExams$, actualShowState.actualShowExams$.value)
  //    const bookedExams = useLocalState<StarterExmsDto[]>(actualShowState.actualShowBookedServices$,actualShowState.actualShowStarters$.getValue )
  //        registrationState.selectedExams$, registrationState.selectedExams$.value)

  /* EFFECTS */
  useEffect(() => {
    if (regId) {
      if (authState.user$.value?.registerId === regId) {
        setPerson(authState.user$.value)
      } else if (Persons?.has(regId)) {
        setPerson(Persons?.get(regId))
      } else {
        new PersonApi(authState.apicfg())
          .apiPersonRegisterRegisterIdGet({ registerId: regId })
          .then((person) => {
            setPerson(person)
            if (person) {
              Persons.set(regId, person)
              setPerson(person)
            }
          })
          .catch(console.error)
      }
    }
  }, [regId])

  /* TEMPLATE */
  if (!person) return <span>n.a.</span>
  return (
    <span>
      {person?.firstName} {person?.lastName}
    </span>
  )
}

export const ExamByStarter = ({ bookedExams }: { bookedExams: BookedExamResponse[] }) => {
  /* TEMPLATE */
  return (
    <DataTable value={bookedExams} style={{ width: '100%' }}>
      <Column
        header='Prüfung'
        body={(exam: BookedExamResponse) => (
          <span>
            <span style={exam?.cancelDate ? { textDecoration: 'line-through', color: '#999' } : {}}>
              {exam.examName ?? exam.examShortName}
              {exam.gweGateExam ? ' (GWE Gang)' : ''}
            </span>
            {exam?.cancelDate && (
              <span style={{ color: 'red', marginLeft: '0.5rem', fontSize: '0.8em' }}>
                storniert {format(exam.cancelDate, 'dd.MM.yyyy')}
              </span>
            )}
          </span>
        )}
      />
      <Column
        header='Preis'
        headerStyle={{ width: '5rem', textAlign: 'right' }}
        bodyStyle={{ width: '5rem', textAlign: 'right', whiteSpace: 'nowrap' }}
        body={(exam: BookedExamResponse) => (
          <span>
            {`${exam.price?.toFixed(2).replace('.', ',')} €`}
          </span>
        )}
      />
    </DataTable>
  )
}

export const ExamByStarterXX = ({ BookedExamResponse }: { BookedExamResponse?: BookedExamResponse | null }) => {
  /* STATE */
  const [totalScore, setTotalScore] = useState<number>(0)
  const [selectedExams, setSelectedExams] = useState<BookedExamResponse[]>([])

  /* EFFECTS */
  useEffect(() => {
    if (BookedExamResponse) {
      /*
          new StartersApi(authState.apicfg())
               .apiStartersValidatePostRaw
              .apiStartersShowShowIdBookerBookerIdGet({ showId: 128, bookerId: Id.toString() })
              .then((response: StarterResponse) => {
                  setSelectedExams(response.bookedExams)
              })
              .catch(console.error)
*/
    }
  }, [BookedExamResponse])

  /* TEMPLATE */
  //  if (!selectedExams.length) return <span>n.a.x</span>
  if (BookedExamResponse == null) return <span>n.a.</span>
  return (
    <div>
      <span>Gesamtsumme der Exams: {BookedExamResponse?.examShortName}</span>
    </div>
  )
}
